import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["role"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["disabled", "title", "innerHTML"]
const _hoisted_4 = ["disabled", "aria-disabled", "title", "innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.buttonWrapperClass),
    role: _ctx.isListItem ? 'listitem' : null
  }, [
    (_ctx.component && _ctx.component.style && _ctx.component.style.type=='link')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onElClick && _ctx.onElClick(...args))),
          type: "button",
          class: _normalizeClass(_ctx.getClass('btn ') + _ctx.getClass('btnLink ') + _ctx.getClass('btnBase ')),
          tabindex: "0",
          style: _normalizeStyle(_ctx.customStyle),
          innerHTML: _ctx.formatMessageContent(_ctx.component.label)
        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_2))
      : (_ctx.component && _ctx.component.style && _ctx.component.style.type=='secondary')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onElClick && _ctx.onElClick(...args))),
            type: "button",
            class: _normalizeClass(_ctx.getClass('btn ') + _ctx.getClass('btnSecondary ') + _ctx.getClass(_ctx.size) + ' '
      + (_ctx.formValid ? '' : _ctx.getClass('btn-disabled')) + ' ' + _ctx.getClass('btnBase ')),
            tabindex: "0",
            disabled: !_ctx.formValid,
            title: !_ctx.formValid ? 'Please fill in all required fields to enable this button.' : '',
            style: _normalizeStyle(_ctx.customStyle),
            innerHTML: _ctx.formatMessageContent(_ctx.component.label)
          }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_3))
        : (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onElClick && _ctx.onElClick(...args))),
            type: "button",
            class: _normalizeClass(_ctx.getClass('btn ') + _ctx.getClass('btnPrimary ') + _ctx.getClass(_ctx.size) + ' '
      + (_ctx.formValid ? '' : _ctx.getClass('btn-disabled')) + ' ' + _ctx.getClass('btnBase ')),
            tabindex: "0",
            disabled: !_ctx.formValid,
            "aria-disabled": !_ctx.formValid,
            title: !_ctx.formValid ? 'Please fill in all required fields to enable this button.' : '',
            style: _normalizeStyle(_ctx.customStyle),
            innerHTML: _ctx.formatMessageContent(_ctx.component.label)
          }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_4)),
    _createCommentVNode(" Visually hidden explanation "),
    (!_ctx.formValid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(_ctx.getClass('visually-hidden'))
        }, " Please fill in all required fields to enable this button. ", 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}